import React, { useState, useEffect } from "react";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";
import "../../styles/addnew.css";

const UOMPopup = ({ closePopup, editData, triggerReload }) => {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [isEditing, setIsEditing] = useState(false);

useEffect(() => {
    if (editData?.id) {
      const fetchData = async () => {
       
        try {
          const response = await axiosInstance.get(`/costsolution/uom/get/${editData.id}`);
          const data = response.data.uom;
          setCode(data.code || "");
          setName(data.name || "");
          setIsEditing(true);
        } catch (error) {
          console.error("Error fetching UOM data:", error);
          toast.error("Failed to load UOM details");
        } 
      };
      
      // If editData has code/name already, use that (Option 1)
      if (editData.code || editData.name) {
        setCode(editData.code || "");
        setName(editData.name || "");
        setIsEditing(true);
      } else {
        // Otherwise fetch (Option 2)
        fetchData();
      }
    }
  }, [editData]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    const uomData = { code, name };

    try {
      const url = isEditing
        ? `/costsolution/uom/${editData?.id}`
        : "/costsolution/uom";

      const method = isEditing ? "put" : "post";

      const response = await axiosInstance[method](url, uomData);

      if (response.data) {
        toast.success(isEditing ? "UOM updated successfully!" : "UOM created successfully!");
        triggerReload();
        handleClear();
        closePopup();
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Something went wrong!");
    }
  };

  const handleClear = () => {
    setCode("");
    setName("");
  };

  return (
    <div className="scope-creation-popup-overlay">
      <div className="scope-creation-popup-container">
        <div className="scope-creation-popup-header">
          <h2>{isEditing ? "Edit UOM" : "Create UOM"}</h2>
          <button className="close-button" onClick={closePopup}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="scope-creation-popup-body">
            <div className="scope-creation-form-group">
              <label htmlFor="code" className="labels">Code</label>
              <input
                type="text"
                id="code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
                style={{ margin: "0px" }}
              />
            </div>

            <div className="scope-creation-form-group">
              <label htmlFor="name" className="name">Name</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                style={{ margin: "0px" }}
              />
            </div>
          </div>

          <div className="scope-creation-popup-footer">
            <button type="button" className="clear-button" onClick={handleClear}>
              Clear
            </button>
            <button type="submit" className="submit-button">
              {isEditing ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


export default UOMPopup
